import * as tooltip from './Tooltip';
export var Tooltip = tooltip.Tooltip;